<template>
  <!-- Material 3 navigation rail for medium and expanded windows -->
  <v-navigation-drawer
    permanent
    :width="80"
    tag="nav"
    aria-label="Main navigation"
    color="surface-container"
    class="nav-rail"
  >
    <div class="d-flex flex-column align-center ga-3 pt-4">
      <router-link
        v-for="item in items"
        :key="item.value"
        :to="{ name: item.value }"
        class="rail-item"
        :class="{ 'rail-item--active': isActive(item.value) }"
        :aria-current="isActive(item.value) ? 'page' : undefined"
      >
        <span class="indicator">
          <v-icon :icon="item.icon" />
        </span>
        <span class="label">{{ item.title }}</span>
      </router-link>
    </div>
  </v-navigation-drawer>
</template>

<script lang="ts">
  import { defineComponent, type PropType } from 'vue';
  import { useRouter } from 'vue-router';
  import type { MenuItem } from '@/components/infrastructure/nav-drawer/NavDrawer.vue';

  export default defineComponent({
    name: 'NavRail',
    props: {
      items: { type: Array as PropType<MenuItem[]>, default: () => [] },
    },
    setup() {
      const router = useRouter();
      return {
        isActive(name: string): boolean {
          return router.currentRoute.value.matched.some(
            (route) => route.name === name,
          );
        },
      };
    },
  });
</script>

<style scoped>
  .nav-rail :deep(.v-navigation-drawer__content) {
    overflow: visible;
  }

  .rail-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 80px;
    min-height: 56px;
    gap: 4px;
    text-decoration: none;
    color: rgba(var(--v-theme-on-surface), var(--v-medium-emphasis-opacity));
  }

  .indicator {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 56px;
    height: 32px;
    border-radius: 16px;
  }

  .rail-item:hover .indicator,
  .rail-item:focus-visible .indicator {
    background: rgba(var(--v-theme-on-surface), var(--v-hover-opacity));
  }

  .rail-item:focus-visible {
    outline: none;
  }

  .rail-item:focus-visible .indicator {
    outline: 2px solid rgb(var(--v-theme-primary));
  }

  .rail-item--active {
    color: rgb(var(--v-theme-on-surface));
  }

  .rail-item--active .indicator {
    background: rgb(var(--v-theme-secondary-container));
    color: rgb(var(--v-theme-on-secondary-container));
  }

  .label {
    font-size: 0.75rem;
    font-weight: 500;
    line-height: 1rem;
    letter-spacing: 0.03125em;
    text-align: center;
  }

  .rail-item--active .label {
    font-weight: 700;
  }
</style>
